/**
 * 处置 strategy 构建专用常量（与 constants/enums、policy-type、ip-address-blocking 保持一致）
 * 独立文件、无 import，避免 dispose-strategy-builder 模块解析异常
 */

export const ApplyScope = {
  Local: 0,
  AllEndpoints: 1,
} as const

export const BlockProtocol = {
  Any: 1,
  Tcp: 2,
  Udp: 3,
} as const

export const BlockDirection = {
  Bidirectional: 1,
  Inbound: 2,
  Outbound: 3,
} as const

export const DisposeAction = {
  BlockIp: 'block_ip',
  BlockUrl: 'block_url',
  IsolateFile: 'isolate_file',
  KillProcess: 'kill_process',
  MarkHandled: 'mark_handled',
  MarkIgnored: 'mark_ignored',
  TrustIp: 'trust_ip',
  TrustUrl: 'trust_url',
  TrustProcess: 'trust_process',
  TrustHash: 'trust_hash',
  TrustFile: 'trust_file',
} as const

export type DisposeActionType = typeof DisposeAction[keyof typeof DisposeAction]

/** PolicySettingType */
export const DisposePolicySettingType = {
  ip_address_blocking: '35',
  internet: '4',
} as const

/** PolicyType */
export const DisposePolicyType = {
  ip_address_blocking: 15,
  internet: 6,
} as const

/** ip-address-blocking PortTypeState / ActionState / frequencyState */
export const IpStrategyField = {
  portTypeCustom: 1,
  actionStopBlocking: 2,
  frequencyDay: 1,
} as const

export const DEFAULT_END_TASK_TIME = [
  { target: 1, start_min: 0, end_min: 23 * 60 + 50 },
]
